import { render } from "./AproposMobile.vue?vue&type=template&id=71177648&scoped=true"
import script from "./AproposMobile.vue?vue&type=script&lang=js"
export * from "./AproposMobile.vue?vue&type=script&lang=js"

import "./AproposMobile.vue?vue&type=style&index=0&id=71177648&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71177648"]])

export default __exports__